const mapTranslations = {
  en: {
    head: {
      index: "network / 14 locations",
      title: "across chapters",
      right: "where we've evolved",
    },
    cities: {
      saoPaulo: "Sao Paulo",
      abidjan: "Abidjan",
      frankfurt: "Frankfurt",
      fulda: "Fulda",
      munich: "Munich",
      berlin: "Berlin",
      prague: "Prague",
      budapest: "Budapest",
      mumbai: "Mumbai",
      pune: "Pune",
      newDelhi: "New Delhi",
      hyderabad: "Hyderabad",
      kolkata: "Kolkata",
      bangkok: "Bangkok",
    },
  },
  de: {
    head: {
      index: "netzwerk / 14 standorte",
      title: "kapitel um kapitel",
      right: "wo wir uns weiterentwickelt haben",
    },
    cities: {
      saoPaulo: "São Paulo",
      abidjan: "Abidjan",
      frankfurt: "Frankfurt",
      fulda: "Fulda",
      munich: "München",
      berlin: "Berlin",
      prague: "Prag",
      budapest: "Budapest",
      mumbai: "Mumbai",
      pune: "Pune",
      newDelhi: "Neu-Delhi",
      hyderabad: "Hyderabad",
      kolkata: "Kolkata",
      bangkok: "Bangkok",
    },
  },
};

export default mapTranslations;
